export const ARRAY_INCLUDES = 'includes' // implement
export const ARRAY_DOES_NOT_INCLUDE = 'doesNotInclude' // implement
export const ARRAY_IS_UNKNOWN = 'unknown' // implement
export const ARRAY_ANY = 'any' // implement

export const arrayOperators = Object.freeze({
    include: {
        key: ARRAY_INCLUDES,
        label: 'Has',
        json: {
            getLogic: (arr, values) => {
                /**
                 * Without 'includes' operator implementation we can do it like this:
                 *
                 *  const obj = {
                    'and': [{
                        'some': [
                            {'var': 'users'},
                            {'==': [{'var': 'uuid'}, 'abc']}
                        ]
                    }, {
                        'some': [
                            {'var': 'users'},
                            {'==': [{'var': 'uuid'}, 'cde']}
                        ]
                    }]
                }
                 * but it will be harder for client side
                 * because
                 *     1) 'doesNotInclude' will also starts with "and" we need to detect operation somehow
                 *     2) we need to divide rule/action key into 2 parts - array name and checked property
                 * */

                return ({
                    [ARRAY_INCLUDES]: [
                        {'var': arr}, values
                    ]
                })
            },
            getData: () => null
        }
    },
    doesNotInclude: {
        key: ARRAY_DOES_NOT_INCLUDE,
        label: 'Doesn\'t have',
        json: {
            getLogic: (arr, values) => ({
                [ARRAY_DOES_NOT_INCLUDE]: [
                    {'var': arr}, values
                ]
            }),
            getData: () => null
        }
    },
    unknown: {
        key: ARRAY_IS_UNKNOWN,
        label: 'Is unknown',
        json: {
            getLogic: (arr, values) => ({
                [ARRAY_IS_UNKNOWN]: [
                    {'var': arr}, values
                ]
            }),
            getData: () => null
        }
    },
    any: {
        key: ARRAY_ANY,
        label: 'Has any value',
        json: {
            getLogic: (arr, values) => ({
                [ARRAY_ANY]: [
                    {'var': arr}, values
                ]
            }),
            getData: () => null
        }
    }
})

export const arrayOperatorsList = Object.freeze(Object.values(arrayOperators))
